import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstMinuta = () => import('./Index')

const router = [
    {
        path: '/',
        component: DefaultContainer,
        children: [
            {
                path: 'lst_minuta',
                name: 'Minuta de Facturacion',
                component: ViewLstMinuta,
                beforeEnter: Permisos.IS_AUTENTICADO,
            },
        ],
    },
]

export default router